// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8d76f4da","667":"8385d472"}[chunkId] + ".chunk.js";
};